<template>
  <Page>
    <template slot="header">
      <img v-show="isLoading" src="./assets/loader.svg" id="loader">
      <div class="small-12 medium-2 columns"><img :src="logo" :alt="'Logo'|t"></div>
      <div class="small-12 medium-8 columns"><MainMenu :routes="mainMenuRoutes"></MainMenu></div>
      <div class="small-12 medium-2 columns"><LanguageSelector></LanguageSelector></div>
    </template>
    <template slot="main">
      <Messages :errors="errorMessages" :statuses="statusMessages" :warnings="warningMessages"></Messages>
      <div v-if="showSideMenu" class="small-2 columns">
        <SideMenu :routes="sideMenuRoutes"></SideMenu>
        <div v-if="isAuthed" id="userid">
          <i :title="'Logged in as user #' + userId" class="icon icon-unlocked"></i>
          <div :title="session_human" :class="progress_class" role="progressbar" id="session_progress">
            <span class="progress-meter" :style="'width: ' + session_progress + '%'"></span>
          </div>
          <div id="credit-info">{{ 'Credit: %d'|t(credit_value) }}</div>
          <router-link :to="{name: 'user.update', params: {user_id: userId}}" tag="a">{{ 'User profile'|t }}</router-link><br>
          <router-link :to="{name: 'registrar.view', params: {id: registrarId}}" tag="a">{{ 'Registrar profile'|t }}</router-link>
        </div>
      </div>
      <div :class="showSideMenu ? 'small-10 columns' : 'small-12 columns'">
        <h1 id="page-title" v-if="pageTitle">{{ pageTitle|t }}</h1>
        <LocalTasks :routes="localTasks"></LocalTasks>
        <ActionsMenu :routes="localActions"></ActionsMenu>
        <router-view/>
      </div>
    </template>
    <template slot="footer">
      <Modal :content="modalContent" :title="modalTitle"></Modal>
    </template>
  </Page>
</template>

<script>
  import Page from '@/components/Page'
  import Messages from '@/components/Messages'
  import LanguageSelector from '@/components/LanguageSelector'
  import MainMenu from '@/components/MainMenu'
  import SideMenu from '@/components/SideMenu'
  import LocalTasks from '@/components/LocalTasks'
  import ActionsMenu from '@/components/ActionsMenu'
  import Modal from '@/components/Modal'
  import '@/assets/foundation.css';
  import '@/assets/icomoon.css';
  import '@/assets/app.css';
  import router from '@/routes';
  import api from '@/api';

  // https://stackoverflow.com/a/23395136/11493911
  let snd = new  Audio("data:audio/wav;base64,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");

export default {
  name: 'App',
  components: {
    Page,
    Messages,
    LanguageSelector,
    MainMenu,
    SideMenu,
    LocalTasks,
    ActionsMenu,
    Modal,
  },
  data: () => {
    return {
      session_progress: 100,
      progress_class: "progress success",
      session_interval: null,
      session_human: "",
      credit_interval: null,
      credit_value: 0,
    }
  },
  props: {
    logo: {
      type: String,
      required: false
    }
  },
  computed: {
    errorMessages() {
      return this.$store.getters['messages/getErrorMessages']
    },
    warningMessages() {
      return this.$store.getters['messages/getWarningMessages']
    },
    statusMessages() {
      return this.$store.getters['messages/getStatusMessages']
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    },
    isAuthed() {
      return this.$store.getters['auth/isAuthed']
    },
    isAnonym() {
      return !this.$store.getters['auth/isAuthed']
    },
    showSideMenu() {
      return this.sideMenuRoutes.length > 0
    },
    isLoading() {
      return this.$store.getters['isLoading']
    },
    pageTitle() {
      return this.$store.getters['pageTitle']
    },
    localTasks() {
      let user = this.$store.getters['user']();
      return this.$store.getters['localTasks'].filter(function(value) {
          for (let i in router.options.routes) {
            let route = router.options.routes[i];
            if (route.name === value.name) {
              let access = route.meta.access;
              if (typeof route.meta.access === "function") {
                access = route.meta.access(user, value.params);
              }
              if (access !== true) {
                return false;
              }
            }
          }
          return true;
      });
    },
    localActions() {
      let user = this.$store.getters['user']();
      return this.$store.getters['localActions'].filter(function(value) {
        for (let i in router.options.routes) {
          let route = router.options.routes[i];
          if (route.name === value.name) {
            let access = route.meta.access;
            if (typeof route.meta.access === "function") {
              access = route.meta.access(user, value.params);
            }
            if (access !== true) {
              return false;
            }
          }
        }
        return true;
      });
    },
    sideMenuRoutes() {
      let user = this.$store.getters['user']();
      let routes = [];
      router.options.routes.forEach(function(route) {
        if (route.meta && route.meta.side_menu) {
          let access = route.meta.access;
          if (typeof route.meta.access === "function") {
            access = route.meta.access(user, router.params);
          }
          if (access !== true) {
            return;
          }

          routes.push({
            name: route.name,
            icon: route.meta.side_menu.icon,
            label: route.meta.side_menu.label,
            weight: route.meta.side_menu.weight || 0
          });
        }
      });

      routes.sort(function(a, b) {
        if (a.weight === b.weight) {
          // this will not work properly for translations
          return a.label.localeCompare(b.label);
        }
        return a.weight > b.weight ? 1 : -1;
      });

      return routes;
    },
    mainMenuRoutes() {
      let user = this.$store.getters['user']();
      let routes = [];
      router.options.routes.forEach(function(route) {
        if (route.meta && route.meta.main_menu) {
          let access = route.meta.access;
          if (typeof route.meta.access === "function") {
            access = route.meta.access(user, route.params);
          }
          if (access !== true) {
            return;
          }

          routes.push({
            name: route.name,
            icon: route.meta.main_menu.icon,
            label: route.meta.main_menu.label,
            weight: route.meta.main_menu.weight || 0
          });
        }
      });

      routes.sort(function(a, b) {
        if (a.weight === b.weight) {
          // this will not work properly for translations
          return a.label.localeCompare(b.label);
        }
        return a.weight > b.weight ? 1 : -1;
      });

      return routes;
    },
    userId() {
      return this.$store.getters['auth/getUserId'];
    },
    registrarId() {
      return this.$store.getters['auth/getRegistrarId'];
    },
    modalContent() {
      return this.$store.getters['modal/getBody']
    },
    modalTitle() {
      return this.$store.getters['modal/getTitle']
    },
  },
  methods: {
    sessionTicker() {
        let exp = this.$store.getters['auth/getSessionExpires'];
        let ss = this.$store.getters['auth/getTokenSet'];
        let now = Math.round((new Date()).getTime() / 1000);
        let diff = exp - now;
        let factor = (exp - ss) / 100;
        let perc = Math.floor(diff / factor);

        if (perc < 0) {
          perc = 0;
        }

        // UI failsafe for when the data is not safe to use(for example when it is not yet available).
        if (perc > 100) {
          perc = 100;
        }

        // use local variable when accommodating "flash" to avoid multiple modifications
        let cls = "progress";

        if (perc >= 75) {
          cls += " success";
        } else if (perc < 75 && perc >= 50) {
          // nothing
        } else if (perc < 50 && perc >= 25) {
          cls += " warning";
        } else {
          cls += " alert"
        }

        if (diff > 0 && diff <= 60) {
          cls += " flash"
        }

        this.progress_class = cls;

        if (diff > 0 && diff <= 10) {
          snd.play();
        }

        // avoid mutating the object if no change is needed
        if (perc !== this.session_progress) {
          this.session_progress = perc;
        }

        if (diff <= 0) {
          let authed = this.$store.getters['auth/isAuthed'];
          if (authed === true) {
            this.$store.dispatch('auth/logout');
          }
        }

      // https://stackoverflow.com/a/25279399/11493911
      this.session_human = new Date(1000 * diff).toISOString().substr(11, 8).replace(/^[0:]+/, "") + "s";
    },
    creditPoller() {
      let authed = this.$store.getters['auth/isAuthed'];
      if (authed) {
        api.getRegistrarCredit({},data => this.credit_value = data.credit);
      } else {
        this.credit_value = 0;
      }
    },
  },
  created() {
    this.session_interval = setInterval(this.sessionTicker, 1000);
    this.credit_interval = setInterval(this.creditPoller, 5000);
  },
  beforeDestroy() {
    clearInterval(this.session_interval);
    clearInterval(this.credit_interval);
  },
  watch: {
    modalContent(after) {
      if (after === "") {
        document.querySelector("html").classList.remove("noscroll");
      } else {
        document.querySelector("html").classList.add("noscroll");
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue